module.exports = __webpack_public_path__ + "img/19.00b55875.svg";